/**
 * Defines constants and static methods useful for timing UI animations
 *
 * @module MW/layout/AnimationTiming
 * @copyright Copyright 2014-2015 The MathWorks, Inc.
 */
define([], function () {
    return {

        /**
         * @static
         */
        UPDATE_INTERVAL: 30,  // milliseconds

        /**
         * @static
         */
        MOVEMENT_RATE: 0.5, // pixels per millisecond

        /**
         * @static
         */
        MIN_DURATION: 200, // milliseconds

        /**
         * @static
         */
        MAX_DURATION: 750,  // milliseconds

        /**
         * Computes an appropriate animation duration for a movement by the specified number of pixels
         *
         * @param offset {number} the move distance in pixels
         * @returns {number} the animation duration in milliseconds
         * @static
         */
        computeDuration: function (offset) {
            return Math.max(this.MIN_DURATION, Math.min(this.MAX_DURATION, Math.abs(offset) / this.MOVEMENT_RATE));
        }
    };
});